/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_InfoInputs */



/**
* | output |
* | --- |
* | "Program Information" |
*
* @param {Subtitle_Export_Program_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_info = /** @type {((inputs?: Subtitle_Export_Program_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations sur le programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programminformationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni sul programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о программе")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información del programa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラム情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम की जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações sobre o programa")
	return /** @type {LocalizedString} */ ("Program Information")
});